import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {L10nModule} from '../../../../../../components/translate';
import {WHeaderTitlePartSymbolModule} from './parts';
import {
    WHeaderTitlePartGroupSharedComponent
} from './parts/w-header-title-part-group-shared/w-header-title-part-group-shared.component';
import {WidgetHeaderTitleComponent} from './widget-header-title.component';

@NgModule({
    imports: [
        CommonModule,
        L10nModule,
        WHeaderTitlePartSymbolModule,
        WHeaderTitlePartGroupSharedComponent
    ],
    declarations: [
        WidgetHeaderTitleComponent
    ],
    exports: [
        WidgetHeaderTitleComponent
    ]
})
export class WidgetHeaderTitleModule {}
